export function isTableItemColorize(itemID: number) {
  return itemID === 0;
}

export function isTableItemHasCirclePointer(itemID: number, keys: Array<any>) {
  return itemID === keys.length - 2;
}
